<template>
  <div class="navBar flex">
    <div
      class="cube flex"
      v-for="(item, index) in listBat"
      :key="index"
      @click="cubeClick(item, index)"
    >
      <div class="circle_one">
        <img :src="item.pic" />
      </div>
      <div>
        <span>{{ item.name }}</span>
        <div class="valueNum">
          <span class="num">{{ item.value }}</span>
          <span class="ys">({{ item.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getScreenV2Hometbzb } from "@/api/home";
import checkPermission from "@/util/permission";
export default {
  data() {
    return {
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: [
        {
          name: "规划面积",
          img: require("images/index/nav/h_ghmj.png"),
          value: 1540,
          unit: "km²"
        },
        {
          name: "实施主体",
          img: require("images/index/nav/h_sszt.png"),
          value: 11,
          unit: "家"
        },
        {
          name: "资金投入",
          img: require("images/index/nav/h_zjtr.png"),
          value: 32,
          unit: "万元"
        },
        {
          name: "建设进度",
          img: require("images/index/nav/h_jsjd.png"),
          value: 72.04,
          unit: "%"
        },
        {
          name: "联农带农",
          img: require("images/index/nav/h_lndn.png"),
          value: 1.5,
          unit: "万户"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getScreenV2Hometbzb().then(res => {
        this.listBat = res.data;
        this.listBat[0].value = this.listBat[0].value / 10000;
        this.listBat[0].pic = require("images/index/nav/h_ghmj.png");
        this.listBat[1].pic = require("images/index/nav/h_sszt.png");
        this.listBat[2].pic = require("images/index/nav/h_zjtr.png");
        this.listBat[3].pic = require("images/index/nav/h_jsjd.png");
        this.listBat[4].pic = require("images/index/nav/h_lndn.png");
        if (this.listBat[1].unit == "家") {
          this.listBat[1].unit = "个";
        }
        console.log("listBat ====", this.listBat);
      });
    },
    cubeClick(item) {
      // 点击切换右则导航
      if (item.code === "ghmj") {
        // this.$store.dispatch("map/setMapComponent", "mapNew");
        this.$bus.$emit("onNavChage", 3);
      } else if (item.code === "sszt") {
        // this.$store.dispatch("map/setMapComponent", "ssztMap");
        this.$bus.$emit("onNavChage", 4);
      } else if (item.code === "yqztz") {
        if (
          checkPermission(["ROLE_ADMIN", "ROLE_CYY_USER", "ROLE_GOVERNMENT"])
        ) {
          //   this.$store.dispatch("map/setMapComponent", "yqztzMap");
          this.$bus.$emit("onNavChage", 7);
        }
      } else if (item.code === "xmzjd") {
        console.log("项目总进度，暂无");
        // this.$store.dispatch("map/setMapComponent", "xmzjdMap");
      } else if (item.code === "lndn") {
        //   this.$store.dispatch("drawer/setRightComponent", "lndnDrawer");
        // this.$store.dispatch("map/setMapComponent", "lndnMap");
        this.$bus.$emit("onNavChage", 8);
      }
      // this.$store.dispatch("map/setMapComponent", "baseMap");
      //   if (item.code !== "lndn") {
      //     this.$store.dispatch("drawer/setRightComponent", "rightDrawer");
      //   }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
  background url('~images/index/nav/navBg.png') center no-repeat
  background-size 100% 100%
  height 100%
  justify-content center
  width 18%
  opacity .9
  cursor pointer

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem

  img
    width .25rem
    height .25rem
    vertical-align middle
</style>
